import React, { useMemo, lazy } from 'react';
import { StarIcon, MapPinIcon } from 'lucide-react';
import { calculateDistance } from '../utils/distanceCalculator';
import { Link } from 'react-router-dom';
import { RecommendedPOIs } from './RecommendedPOIs';
export const AccommodationCard = ({
  accommodation,
  onHover,
  onLeave,
  selectedPOIs,
  poiCategories
}) => {
  // Calculate nearby POIs with distances
  const nearbyPOIs = useMemo(() => {
    if (!selectedPOIs || selectedPOIs.length === 0) return [];
    const result = [];
    // Loop through selected POI categories
    selectedPOIs.forEach(poiType => {
      const category = poiCategories.find(cat => cat.type === poiType);
      if (!category) return;
      // Calculate distance for each POI in this category
      const poisWithDistance = category.items.map(poi => {
        const distance = calculateDistance(accommodation.lat, accommodation.lng, poi.lat, poi.lng);
        return {
          ...poi,
          distance,
          categoryType: category.type,
          categoryLabel: category.label,
          icon: category.icon
        };
      });
      // Sort by distance and take the closest 2
      const closestPOIs = poisWithDistance.sort((a, b) => a.distance - b.distance).slice(0, 2);
      result.push(...closestPOIs);
    });
    // Return the 5 closest POIs overall
    return result.sort((a, b) => a.distance - b.distance).slice(0, 5);
  }, [accommodation, selectedPOIs, poiCategories]);
  return <div className="border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition" onMouseEnter={onHover} onMouseLeave={onLeave} data-id="element-18">
      <div className="flex flex-col sm:flex-row" data-id="element-19">
        <div className="sm:w-1/3 h-48 sm:h-auto relative" data-id="element-20">
          <img src={accommodation.image} alt={accommodation.title} className="absolute inset-0 w-full h-full object-cover" loading="lazy" onError={e => {
          console.error(`Failed to load image: ${accommodation.image}`);
          e.currentTarget.src = 'https://images.unsplash.com/photo-1518780664697-55e3ad937233?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2065&q=80';
        }} data-id="element-21" />
        </div>
        <div className="p-4 sm:w-2/3" data-id="element-22">
          <div className="flex justify-between" data-id="element-23">
            <h3 className="font-semibold text-lg" data-id="element-24">{accommodation.title}</h3>
            <div className="flex items-center" data-id="element-25">
              <StarIcon size={16} className="fill-current text-black" data-id="element-26" />
              <span className="ml-1" data-id="element-27">{accommodation.rating}</span>
            </div>
          </div>
          <p className="text-gray-500 text-sm mt-1" data-id="element-28">{accommodation.location}</p>
          <p className="text-gray-600 mt-2" data-id="element-29">{accommodation.description}</p>
          {/* Personalized POI recommendations */}
          <RecommendedPOIs nearbyPOIs={nearbyPOIs} data-id="element-30" />
          <div className="flex justify-between items-center mt-4" data-id="element-31">
            <div className="text-lg font-semibold" data-id="element-32">
              ${accommodation.price}{' '}
              <span className="text-sm font-normal" data-id="element-33">night</span>
            </div>
            <Link to={`/accommodation/${accommodation.id}`} data-id="element-34">
              <button className="bg-rose-500 text-white px-4 py-2 rounded-lg hover:bg-rose-600 transition" data-id="element-35">
                View
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>;
};